import React, { FC, useEffect } from 'react';
import { useRouter } from 'next/router';
import Text from '@components/common/text';
import ApplyList from './applyList';
import { FontStyle } from '@domain/constant/fontStyle';
import useMessageModal from '@utils/hooks/useMessageModal';
import classnames from 'classnames/bind';
import styles from './applyStatus.module.scss';
const cx = classnames.bind(styles);

const ApplyStatus: FC = () => {
  const { openMessageModal } = useMessageModal();
  const { query } = useRouter();

  useEffect(() => {
    if (!query.sn || isNaN(Number(query.sn))) return;
    openMessageModal(Number(query.sn));
  }, [query]);

  return (
    <>
      <div className={cx('wrap')}>
        <Text fontStyle={FontStyle.H4_B}>작성 중인 지원서</Text>

        <ApplyList />
      </div>
    </>
  );
};

export default ApplyStatus;
